import api from '@/services/Api';

export default {
    getSlider(){
        return api.get('/api/v1/slider')
    }
}